<template>
  <div class="loading-page">
    <div class="loading-panel">
      <div class="loader">
        <div class="dot dot1">
          <i />
        </div>
        <div class="dot dot2">
          <i />
        </div>
        <div class="dot dot3">
          <i />
        </div>
        <div class="dot dot4">
          <i />
        </div>
        <div class="dot dot5">
          <i />
        </div>
        <div class="dot dot6">
          <i />
        </div>
        <div class="dot dot7">
          <i />
        </div>
        <div class="dot dot8">
          <i />
        </div>
        <div class="dot dot9">
          <i />
        </div>
      </div>
      <div class="loading-message">系统初始化中...</div>
    </div>
  </div>
</template>

<script>
// import router from "@/frameworks/router";
import store from '@/frameworks/store'
import { getUrlRootPath } from '@/common/utils/pathTools'

const getFirstAccessMenu = function (menuDtos) {
  for (let i = 0; i < menuDtos.length; i++) {
    if (menuDtos[i].children && menuDtos[i].children.length > 0) {
      return getFirstAccessMenu(menuDtos[i].children)
    } else {
      return menuDtos[i]
    }
  }
}

export default {
  name: 'AppLoadingPage',
  components: {},
  props: {},
  data() {
    return {}
  },

  computed: {},

  created() {
    for (var key in this.$route.query) {
      var lowerkey = key.toLowerCase()
      this.$route.query[lowerkey] = this.$route.query[key]
    }
    if (this.$route.query.hospitalCode) {
      if (window.globalConfig.isSkipMutiHospital) {
        store.commit('SET_HOSPITAL_CODE', null)
      } else {
        store.commit('SET_HOSPITAL_CODE', this.$route.query.hospitalCode)
      }
    }
    // 获取登录用户信息
    const navStyle = this.$route.query['navStyle'] || 'nonTopMenu' //'nonNav','topNav'
    if (navStyle) {
      store.dispatch('setNavStyle', navStyle)
    }
    const param = {
      skipPwd: true,
      UserId:
        this.$route.query.UserId ||
        this.$route.query.userid ||
        this.$route.query.userId ||
        this.$route.query.uid ||
        '',
      Password: this.$route.query.skipPwd ? '' : this.$route.query.pwd,
      LoginFlag: this.$route.query.loginflag || '',
      Captcha: this.$route.query.captcha || ''
    }
    store
      .dispatch('GetLoginUserInfo', param)
      .then((data) => {
        // 成功则跳转到登录前的页面.
        // 获取路由中的跳转参数.
        const redirectUrl = this.$route.query['redirect']
        if (
          redirectUrl &&
          !(redirectUrl === '/' || redirectUrl.startsWith('/?'))
        ) {
          this.$router.push(redirectUrl)
        } else {
          // 获得第一个菜单项，直接打开.
          const firstMenuDto = getFirstAccessMenu(data.menus || [])
          const gotoPage = firstMenuDto ? firstMenuDto.fullPath : '/'
          store.dispatch('getSystemParam').then((res) => {
            this.$router.push(gotoPage)
          })
        }
        store.dispatch('getIsMulHospital')
      })
      .catch((e) => {
        // 如果不能获取到用户信息，说明当前的登录信息已经失效，提示用户并退出登录，重新定位到登录页面.
        this.$dlg.alert('当前登录用户信息已失效，请点击 确认 重新登录', {
          messageType: 'confirm',
          callback: () => {
            let logoutUrl = window.serverConfig.BASE_API + '/logout'
            if (this.$route.query.redirect) {
              const callback =
                getUrlRootPath() + '#' + this.$route.query.redirect
              logoutUrl =
                logoutUrl + '?callback=' + encodeURIComponent(callback)
            }
            window.location.href = logoutUrl
          }
        })
        // this.$router.push("/500");
      })
  },

  methods: {}
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.loading-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: white;
}
.loading-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 120px;
  height: 20px;
}
.loading-message {
  font-size: 13px;
  padding-top: 20px;
  color: #1581de;
  text-align: center;
}
.loader {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 120px;
  height: 20px;
}

.dot {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 0 5px;
  height: 20px;
  width: 2px;
}

.dot:first-of-type {
  margin-left: 0;
}

.dot:last-of-type {
  margin-right: 0;
}

.dot::before,
.dot::after {
  content: '';
  position: absolute;
  bottom: -5px;
  display: block;
  width: 4px;
  height: 4px;
  background: #4204ff;
  border-radius: 4px;
  box-shadow: 1px 1px 6px 2px rgba(26, 11, 255, 0.15);
  animation: helix 1.25s ease-in-out infinite;
}

.dot::after {
  bottom: 100%;
  animation: helix-reversed 1.25s ease-in-out infinite;
}

.dot i {
  position: absolute;
  z-index: 25;
  align-self: center;
  width: 1px;
  height: 10px;
  background: rgba(48, 45, 255, 0.75);
  animation: helix-bar 1.25s ease-in-out infinite;
}

.dot2::before,
.dot2::after,
.dot2 i {
  animation-delay: 0.05s;
}

.dot3::before,
.dot3::after,
.dot3 i {
  animation-delay: 0.1s;
}

.dot4::before,
.dot4::after,
.dot4 i {
  animation-delay: 0.15s;
}

.dot5::before,
.dot5::after,
.dot5 i {
  animation-delay: 0.2s;
}

.dot6::before,
.dot6::after,
.dot6 i {
  animation-delay: 0.25s;
}

.dot7::before,
.dot7::after,
.dot7 i {
  animation-delay: 0.3s;
}

.dot8::before,
.dot8::after,
.dot8 i {
  animation-delay: 0.35s;
}

.dot9::before,
.dot9::after,
.dot9 i {
  animation-delay: 0.4s;
}

@keyframes helix {
  0% {
    width: 5px;
    height: 5px;
    bottom: -5px;
    z-index: 10;
  }
  25% {
    width: 2px;
    height: 2px;
  }
  50% {
    width: 5px;
    height: 5px;
    bottom: 100%;
    z-index: 20;
  }
  75% {
    width: 9px;
    height: 9px;
  }
  100% {
    width: 5px;
    height: 5px;
    bottom: -5px;
  }
}

@keyframes helix-reversed {
  0% {
    width: 5px;
    height: 5px;
    bottom: 100%;
    z-index: 20;
  }
  25% {
    width: 8px;
    height: 8px;
  }
  50% {
    width: 5px;
    height: 5px;
    bottom: -5px;
    z-index: 10;
  }
  75% {
    width: 2px;
    height: 2px;
  }
  100% {
    width: 5px;
    height: 5px;
    bottom: 100%;
  }
}

@keyframes helix-bar {
  0% {
    height: 15px;
  }
  25% {
    height: 8px;
  }
  50% {
    height: 15px;
  }
  75% {
    height: 8px;
  }
  100% {
    height: 15px;
  }
}
</style>
